import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ShopifyConnectionScreen = lazy(
  () => import('~/features/item-setup/pages/shopify-connection-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/shopify')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ShopifyConnectionScreen />
    </Suspense>
  ),
});
